import { CreationToolWrapperProps } from "@kaltura/mediaspace-shared-search-and-select";
import { getComponentFromPath, translate } from "@kaltura/mediaspace-shared-utils";
import { ErrorBoundary } from "@kaltura/mediaspace-shared-ui";
import { Button, Typography } from "@kaltura/ds-react-components";
import { ArrowLeft24Icon } from "@kaltura/ds-react-icons";
import { KalturaMediaEntry } from "kaltura-typescript-client/api/types/KalturaMediaEntry";

interface AddQuizCreationToolWrapperProps extends CreationToolWrapperProps {
    onSubmit: (entry: KalturaMediaEntry) => void;
}

/**
 * Creation tool (upload, recorder, etc.) wrapper for the quiz creation page.
 */
export const CreationToolWrapper = (props: AddQuizCreationToolWrapperProps) => {
    const { creationTool, onBack, onSubmit } = props;

    const { component } = creationTool;
    const CreationTool = getComponentFromPath(component);

    return (
        <div>
            <Button variant={"borderless"} color={"secondary"} startIcon={<ArrowLeft24Icon />} onClick={onBack}>
                {translate("Back")}
            </Button>

            <ErrorBoundary>
                <Typography component={"h1"} variant="h2">
                    {creationTool.props.title}
                </Typography>
                <CreationTool {...creationTool.props} onSubmit={onSubmit} onBack={onBack} />
            </ErrorBoundary>
        </div>
    );
};
